<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import SitesList from '@components/sites-list.vue'
import CameraInfo from '@components/camera-info.vue'
import CameraTemperature from '@components/camera-temperature.vue'
import CameraPanorama from '@components/camera-panorama.vue'

export default {
  page: {
    title: 'Camera details',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    SitesList,
    CameraInfo,
    CameraTemperature,
    CameraPanorama
  },
  props: {
    camera: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedPreset: null,
      latestTempTime: null,
      isOnline: true,
    }
  },
  methods: {
    onSelectedPreset(preset) {
      this.selectedPreset = preset;
    },
    onLatestTempTime(latestTempTime) {
      this.latestTempTime = latestTempTime;
      this.isOnline = ((new Date()).getTime() - latestTempTime) < 300000;
    }
  }
}
</script>

<template>
  <Layout>
    <div :class="$style.cameraPage">
      <aside id="sidebar" :class="$style.sidebar">
        <SitesList display-mode="minimal"></SitesList>
      </aside>
      <div id="main" :class="$style.main">
        <CameraInfo :camera="camera" :is-online="isOnline"></CameraInfo>
        <CameraPanorama :camera="camera" @selectedPreset="onSelectedPreset" @latestTempTime="onLatestTempTime"></CameraPanorama>
        <CameraTemperature :camera="camera" :selected-preset="selectedPreset"></CameraTemperature>
        <div :class="$style.toolbar">
          <a
            v-scroll-to="'#header'"
            href="javascript:void(0)"
            :class="$style.button"
            >Back to top <svg width="24" height="24" viewBox="0 0 13 8" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.801 2.247A1.019 1.019 0 01.801.8a1.03 1.03 0 011.453 0L6.5 5.03 10.746.8a1.03 1.03 0 011.754.723c0 .262-.1.524-.301.724L7.226 7.2a1.033 1.033 0 01-1.452 0L.8 2.247z" fill="currentColor"/></svg></a>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.cameraPage {
  display: flex;
}

.sidebar {
  display: none;

  @media (min-width: 1200px) {
    position: sticky;
    top: 0;
    display: flex;
    flex: 0 0 450px;
    height: 100vh;
    padding-right: 32px;
    margin-right: 32px;
    overflow-y: scroll;
  }
}

.main {
  @media (min-width: 1200px) {
    flex-grow: 1;
  }

  .toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 80px;

    .button {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 39px;
      padding: 0 15px;
      color: transparentize($color-text, 0.29);
      text-decoration: none;
      border: solid 1px $color-user-dropdown-border;
      border-radius: 24px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);

      svg {
        width: 10px;
        height: 22px;
        margin-left: 10px;
        color: $color-primary;
        transform: rotate(180deg);
      }

      &:hover {
        color: $color-white;
        background: $color-button-bg;
        background-image: $color-button-bg-gradient;

        svg {
          color: $color-white;
        }
      }
    }
  }
}
</style>
